export interface PresetItem {
  displayName?: string;
  key: string;
  isDefault: boolean;
}
export interface CollectionItem extends PresetItem {
  displayName: string;
  types: PresetItem[];
  itemProperties: PresetItem[];
}
export default [
  {
    displayName: 'Addresses',
    key: 'addresses',
    itemProperties: [
      {
        key: 'country',
        isDefault: false,
      },
      {
        key: 'countryCode',
        isDefault: false,
      },
      {
        key: 'extendedAddress',
        isDefault: false,
      },
      {
        key: 'formatted',
        isDefault: true,
      },
      {
        key: 'locally',
        isDefault: false,
      },
      {
        key: 'poBox',
        isDefault: false,
      },
      {
        key: 'region',
        isDefault: false,
      },
      {
        key: 'sourceIsStructured',
        isDefault: false,
      },
      {
        key: 'streetAddress',
        isDefault: false,
      },
    ],
    types: [
      { displayName: 'Primary*', key: 'primary', isDefault: true },
      {
        key: 'work',
        isDefault: false,
      },
      {
        key: 'home',
        isDefault: false,
      },
      {
        key: 'other',
        isDefault: false,
      },
      {
        key: 'custom',
        isDefault: false,
      },
    ],
  },
  {
    displayName: 'Emails',
    key: 'emails',
    itemProperties: [
      {
        key: 'address',
        isDefault: true,
      },
    ],
    types: [
      { displayName: 'Primary*', key: 'primary', isDefault: true },
      {
        key: 'work',
        isDefault: false,
      },
      {
        key: 'home',
        isDefault: false,
      },
      {
        key: 'other',
        isDefault: false,
      },
      {
        key: 'custom',
        isDefault: false,
      },
    ],
  },
  {
    displayName: 'ExternalIDs',
    key: 'externalIds',
    itemProperties: [
      {
        key: 'value',
        isDefault: true,
      },
    ],
    types: [
      {
        key: 'account',
        isDefault: true,
      },
      {
        key: 'custom',
        isDefault: false,
      },
      {
        key: 'customer',
        isDefault: false,
      },
      {
        key: 'login_id',
        isDefault: false,
      },
      {
        key: 'network',
        isDefault: false,
      },
      {
        key: 'organization',
        isDefault: false,
      },
    ],
  },
  {
    displayName: 'Instant Messengers',
    key: 'ims',
    itemProperties: [
      {
        key: 'customProtocol',
        isDefault: false,
      },
      {
        key: 'customType',
        isDefault: false,
      },
      {
        key: 'im',
        isDefault: true,
      },
      {
        key: 'protocol',
        isDefault: false,
      },
    ],
    types: [
      { displayName: 'Primary*', key: 'primary', isDefault: true },
      {
        key: 'work',
        isDefault: false,
      },
      {
        key: 'home',
        isDefault: false,
      },
      {
        key: 'other',
        isDefault: false,
      },
      {
        key: 'custom',
        isDefault: false,
      },
    ],
  },
  {
    displayName: 'Keywords',
    key: 'keywords',
    itemProperties: [
      {
        key: 'value',
        isDefault: true,
      },
    ],
    types: [
      {
        key: 'mission',
        isDefault: false,
      },
      {
        key: 'occupation',
        isDefault: true,
      },
      {
        key: 'outlook',
        isDefault: false,
      },
      {
        key: 'custom',
        isDefault: false,
      },
    ],
  },
  {
    displayName: 'Locations',
    key: 'locations',
    itemProperties: [
      {
        key: 'area',
        isDefault: true,
      },
      {
        key: 'buildingId',
        isDefault: false,
      },
      {
        key: 'deskCode',
        isDefault: false,
      },
      {
        key: 'floorName',
        isDefault: false,
      },
      {
        key: 'floorSection',
        isDefault: false,
      },
    ],
    types: [
      {
        key: 'custom',
        isDefault: false,
      },
      {
        key: 'default',
        isDefault: true,
      },
      {
        key: 'desk',
        isDefault: false,
      },
    ],
  },
  {
    displayName: 'Organizations',
    key: 'organizations',
    itemProperties: [
      {
        key: 'costCenter',
        isDefault: false,
      },
      {
        key: 'department',
        isDefault: false,
      },
      {
        key: 'description',
        isDefault: false,
      },
      {
        key: 'domain',
        isDefault: false,
      },
      {
        key: 'fullTimeEquivalent',
        isDefault: false,
      },
      {
        key: 'location',
        isDefault: false,
      },
      {
        key: 'name',
        isDefault: true,
      },
      {
        key: 'symbol',
        isDefault: false,
      },
      {
        key: 'title',
        isDefault: false,
      },
    ],
    types: [
      { displayName: 'Primary*', key: 'primary', isDefault: true },
      {
        key: 'domain_only',
        isDefault: false,
      },
      {
        key: 'school',
        isDefault: false,
      },
      {
        key: 'unknown',
        isDefault: false,
      },
      {
        key: 'work',
        isDefault: false,
      },
    ],
  },
  {
    displayName: 'Phones',
    key: 'phones',
    itemProperties: [
      {
        key: 'value',
        isDefault: true,
      },
    ],
    types: [
      { displayName: 'Primary*', key: 'primary', isDefault: true },
      {
        key: 'assistant',
        isDefault: false,
      },
      {
        key: 'callback',
        isDefault: false,
      },
      {
        key: 'car',
        isDefault: false,
      },
      {
        key: 'company_main',
        isDefault: false,
      },
      {
        key: 'custom',
        isDefault: false,
      },
      {
        key: 'grand_central',
        isDefault: false,
      },
      {
        key: 'home',
        isDefault: false,
      },
      {
        key: 'home_fax',
        isDefault: false,
      },
      {
        key: 'isdn',
        isDefault: false,
      },
      {
        key: 'main',
        isDefault: false,
      },
      {
        key: 'mobile',
        isDefault: false,
      },
      {
        key: 'other',
        isDefault: false,
      },
      {
        key: 'other_fax',
        isDefault: false,
      },
      {
        key: 'pager',
        isDefault: false,
      },
      {
        key: 'radio',
        isDefault: false,
      },
      {
        key: 'telex',
        isDefault: false,
      },
      {
        key: 'tty_tdd',
        isDefault: false,
      },
      {
        key: 'work',
        isDefault: false,
      },
      {
        key: 'work_fax',
        isDefault: false,
      },
      {
        key: 'work_mobile',
        isDefault: false,
      },
      {
        key: 'work_pager',
        isDefault: false,
      },
    ],
  },
  {
    displayName: 'Relations',
    key: 'relations',
    itemProperties: [
      {
        key: 'value',
        isDefault: true,
      },
    ],
    types: [
      {
        key: 'admin_assistant',
        isDefault: false,
      },
      {
        key: 'assistant',
        isDefault: true,
      },
      {
        key: 'bother',
        isDefault: false,
      },
      {
        key: 'child',
        isDefault: false,
      },
      {
        key: 'custom',
        isDefault: false,
      },
      {
        key: 'domestic_partner',
        isDefault: false,
      },
      {
        key: 'dotted_line_manager',
        isDefault: false,
      },
      {
        key: 'exec_assistant',
        isDefault: false,
      },
      {
        key: 'father',
        isDefault: false,
      },
      {
        key: 'friend',
        isDefault: false,
      },
      {
        key: 'manager',
        isDefault: false,
      },
      {
        key: 'mother',
        isDefault: false,
      },
      {
        key: 'parent',
        isDefault: false,
      },
      {
        key: 'partner',
        isDefault: false,
      },
      {
        key: 'referred_by',
        isDefault: false,
      },
      {
        key: 'relative',
        isDefault: false,
      },
      {
        key: 'sister',
        isDefault: false,
      },
      {
        key: 'spouse',
        isDefault: false,
      },
    ],
  },
  {
    displayName: 'Websites',
    key: 'websites',
    itemProperties: [
      {
        key: 'value',
        isDefault: true,
      },
    ],
    types: [
      {
        key: 'app_install_page',
        isDefault: false,
      },
      {
        key: 'blog',
        isDefault: false,
      },
      {
        key: 'custom',
        isDefault: false,
      },
      {
        key: 'ftp',
        isDefault: false,
      },
      {
        key: 'home',
        isDefault: true,
      },
      {
        key: 'home_page',
        isDefault: false,
      },
      {
        key: 'other',
        isDefault: false,
      },
      {
        key: 'profile',
        isDefault: false,
      },
      {
        key: 'reservations',
        isDefault: false,
      },
      {
        key: 'resume',
        isDefault: false,
      },
      {
        key: 'work',
        isDefault: false,
      },
    ],
  },
] as CollectionItem[];
